import React, { useEffect } from 'react';
import { Snackbar, Stack } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const Snackbarfrom = (props) => {
  const [open, setOpen] = React.useState(false);
  const snackBarProps = props;

  useEffect(() => {
    setOpen(true);
  }, snackBarProps?.snackBarMsg?.msg)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    props.setSnackbarMsg({})
    setOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Alert onClose={handleClose}
          severity={snackBarProps?.snackBarMsg?.severity}
          sx={{ width: '100%' }}
        >
          {snackBarProps?.snackBarMsg?.msg}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
export default Snackbarfrom